// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"EditPermissions_checkBox__b9qu9"};